// extracted by mini-css-extract-plugin
export default {"wrapper":"LA-z","viewport":"MA-z","container":"NA-z","slide":"OA-z"};